import { ActionTypes } from './constants';
import * as Models from './models';

export const aiTranslate: Models.ActionCreator.AITranslate = () => ({
  type: ActionTypes.AI_TRANSLATE,
});
